import type { GameInfoType } from '@patrianna/shared-patrianna-types/store/SlotGameFlowModule'
import cx from 'classnames'

type Props = {
  gameBetsAndPrizes: GameInfoType & { maxWinMultiplier: number }
  title: string
  captionClassName: string
  descriptionClassName: string
}

function MaxWinContainer({ title, gameBetsAndPrizes, captionClassName, descriptionClassName }: Props) {
  return (
    <>
      <span className={cx('mt-typography-caption', captionClassName)}>{title}</span>
      <span className={cx('mt-typography-caption', descriptionClassName)}>
        <b>{`x ${gameBetsAndPrizes.maxWinMultiplier}`}</b>
      </span>
    </>
  )
}

export default MaxWinContainer
